export default __webpack_public_path__ + "static/media/screen2.49316e3e.png";